import { Button, LoadingButton } from "components/form";
import { getFromLocal } from "config/axiosInstance";
import React, { useState } from "react";
import { createSurveyApi } from "services/survey";
import { removeEmptyValues } from "utils/commonHelper";
import { toastMessage } from "utils/toastMessageHelper";

const PublistSurveyModel = ({
  handleClose,
  selectedSurveyId,
  setSurveyList,
}) => {
  // set all value
  const [publishSurveyLoader, setPublishSurveyLoader] = useState(false);

  // Create Survey function handler
  const publishSelectedSurveyHandler = async () => {
    //  if (validation()) {
    try {
      setPublishSurveyLoader(true);
      const reqData = {
        publishSurvey: true,
        isCompleted: true,
        token: getFromLocal() || "",
        surveyId: selectedSurveyId,
      };
      const responseData = await createSurveyApi(removeEmptyValues(reqData));
      const { message = "", status: requstStatus } = responseData;
      if (requstStatus === 200) {
        toastMessage(message, "success", "createNewSurvey");
        setSurveyList((prev) =>
          prev.map((survey) =>
            survey._id === selectedSurveyId
              ? { ...survey, surveyStatus: "ongoing", publishSurvey: true }
              : survey
          )
        );
        handleClose()
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setPublishSurveyLoader(false);
    }
  };

  return (
    <div className="wrap_log_modal">
      <h3>Are you sure you want to publish this survey</h3>
      <div className="button_wrap button_center">
        <LoadingButton
          className={"light"}
          loading={publishSurveyLoader}
          onClick={publishSelectedSurveyHandler}
        >
          Yes
        </LoadingButton>
        <Button onClick={handleClose}>No</Button>
      </div>
    </div>
  );
};

export default PublistSurveyModel;
